import {
    extractProperties,
    isEmpty,
} from '.'
import {CaseReducer} from '@reduxjs/toolkit'
import {NinchatCommentCreatedEvent} from '../types/events'
import {NinchatState} from 'api/types'

export const commentCreated: CaseReducer<NinchatState> = (state, action) => {
    const {
        audience_id,
        comment_change,
        comment_id,
        comment_text,
        comment_time,
        comment_user_id,
        queue_id,
        ...rest
    } = extractProperties<NinchatCommentCreatedEvent>(action.payload)

    isEmpty(rest)

    state._user_audience_comments[queue_id] ??= {}
    state._user_audience_comments[queue_id][audience_id] ??= []

    state._user_audience_comments[queue_id][audience_id].unshift({
        change: comment_change,
        id: comment_id,
        text: comment_text,
        time: comment_time,
        user_id: comment_user_id,
    })
}
